import React, {useState} from 'react';
import {t} from '@lingui/core/macro';
import {ItemDataType} from 'rsuite/cjs/@types/common';
import {SelectPicker} from 'rsuite';
import cn from 'classnames';

import Correct from 'shared/ui/icons/General/Correct';
import Sort from 'shared/ui/icons/General/Sort';
import IOrderBy, {DirectionType} from 'shared/model/IOrderBy';
import {isTranslate} from 'shared/lib/lang';

import {PALETTE} from 'shared/config/model/palette';
import {brandColor} from 'shared/lib/colors';

import styles from './OrderBy.module.scss';

export interface IOrderByProps {
    data: ItemDataType<string>[],
    name: string,
    // eslint-disable-next-line no-unused-vars
    onChange?: (value?: IOrderBy) => void,
    defaultValue?: IOrderBy,
}

const OrderBy: React.FC<IOrderByProps> = ({
    data,
    onChange,
    defaultValue,
    name,
}) => {
    const [value, setValue] = useState<IOrderBy|undefined>(defaultValue);

    const handleChangeField = (field: string|null) => {
        const newValue = field
            ? {...value, field: field as string}
            : value?.direction ? {field: undefined, direction: value.direction} : undefined;
        setValue(newValue);
        onChange?.(newValue);
    };

    const handleChangeDirection = (direction: DirectionType|null) => {
        const newValue = direction
            ? {...value, direction}
            : value?.field ? {field: value.field, direction: undefined} : undefined;
        setValue(newValue);
        onChange?.(newValue);
    };

    const directions: ItemDataType<DirectionType>[] = [
        {label: `${t`По возрастанию`}`, value: 'asc'},
        {label: `${t`По убыванию`}`, value: 'desc'},
    ];

    const getIcon = (hasValue: boolean) => {
        return hasValue
            ? <Correct color={brandColor(PALETTE.accent, PALETTE.success)}/>
            : <Sort />;
    };

    return (
        <div className={styles.wrapper}>
            <div className={cn(
                styles.select_container,
                isTranslate() && styles.enContainer,
            )}>
                <div className={styles.icon}>
                    {getIcon(!!value?.field)}
                </div>
                <SelectPicker
                    className={cn(
                        styles.select,
                        isTranslate() && styles.enSelect,
                    )}
                    name={`${name}.field`}
                    menuClassName={isTranslate() ? 'english-select-menu' : ''}
                    cleanable={true}
                    onChange={(value) => {
                        handleChangeField(value);
                    }}
                    defaultValue={value?.field}
                    data={data}
                    placeholder={t`Выберите поле`}
                    searchable={false}
                    preventOverflow={false}
                />
            </div>
            <div className={cn(
                styles.select_container,
                isTranslate() && styles.enContainer,
            )}>
                <div className={styles.icon}>
                    {getIcon(!!value?.direction)}
                </div>
                <SelectPicker
                    className={cn(
                        styles.select,
                        isTranslate() && styles.enSelect,
                    )}
                    menuClassName={isTranslate() ? 'english-select-menu' : ''}
                    name={`${name}.direction`}
                    cleanable={true}
                    onChange={(value) => {
                        handleChangeDirection(value);
                    }}
                    data={directions}
                    defaultValue={value?.direction}
                    placeholder={t`Выберите направление`}
                    searchable={false}
                    preventOverflow={false}
                />
            </div>
        </div>
    );
};

export default OrderBy;